var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_9",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.003 488.003",
    style: {
      enableBackground: "new 0 0 488.003 488.003"
    },
    xmlSpace: "preserve",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "deployment"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.003,323.999h-144v-48c-0.001-4.418-3.583-7.999-8.002-7.998c-2.121,0-4.154,0.843-5.654,2.342l-96,96    c-3.04,3.036-3.139,7.932-0.224,11.088l96,104c1.516,1.639,3.648,2.57,5.88,2.568c4.418,0,8-3.582,8-8v-48h144    c4.418,0,8-3.582,8-8v-88C264.003,327.581,260.421,323.999,256.003,323.999z M248.003,411.999h-144c-4.418,0-8,3.582-8,8v35.536    l-76.904-83.32l76.904-76.904v36.688c0,4.418,3.582,8,8,8h144V411.999z",
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.397,111.198c-0.392-0.523-0.847-0.995-1.355-1.407h0l-128-104c-3.431-2.784-8.469-2.258-11.253,1.173    c-1.155,1.424-1.786,3.202-1.787,5.035v48h-112c-4.418,0-8,3.582-8,8v88c0,4.418,3.582,8,8,8h112v48c0,4.418,3.582,8,8,8    c1.731,0,3.415-0.561,4.8-1.6l128-96C480.336,119.746,481.05,114.732,478.397,111.198z M352.003,195.999v-40c0-4.418-3.582-8-8-8    h-112v-72h112c4.418,0,8-3.582,8-8v-39.2l107,86.952L352.003,195.999z",
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.003,
    y: 59.999,
    width: 64,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104.003,
    y: 59.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.003,
    y: 107.999,
    width: 56,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.003,
    y: 147.999,
    width: 32,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.003,
    y: 147.999,
    width: 48,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.003,
    y: 147.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.003,
    y: 147.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.003,
    y: 107.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.003,
    y: 107.999,
    width: 40,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 107.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.003,
    y: 323.999,
    width: 80,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 376.003,
    y: 323.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.003,
    y: 371.999,
    width: 56,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.003,
    y: 411.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 368.003,
    y: 411.999,
    width: 48,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.003,
    y: 411.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 472.003,
    y: 411.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.003,
    y: 371.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.003,
    y: 371.999,
    width: 48,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.003,
    y: 371.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 312.003,
    y: 411.999,
    width: 16,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 432.003,
    y: 323.999,
    width: 48,
    height: 16,
    fill: "#cb1ac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.003,
    y: 59.999,
    width: 48,
    height: 16,
    fill: "#cb1ac5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.8bf5ae891140c92a1ed3a9f223286b10.svg";
export { ForwardRef as ReactComponent };